/**
 * @file コンポーネント：見出し DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import { StyledHeadline } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledHeadline data-font-size={props.fontSize} ref={props.refHeadline}>
            <props.tag
                data-font-size={props.fontSize}
                data-font-weight={props.fontWeight}
                data-on-color={props.onColor}
                data-text-align={props.textAlign}
                ref={props.refHeadlineContainer}
            >
                {props.text}
            </props.tag>
        </StyledHeadline>
    );
};
